import styled from 'styled-components';
import { Table, Th, Td } from 'next/components/ui';

export const UITable = styled(Table)`
  ${Th}:nth-child(1), ${Td}:nth-child(1) {
    width: 262px;
  }

  ${Th}:nth-child(2), ${Td}:nth-child(2) {
    max-width: 218px;
  }

  ${Th}:nth-child(3), ${Td}:nth-child(3) {
    max-width: 259px;
  }

  ${Th}:nth-child(4), ${Td}:nth-child(4) {
    width: 209px;
  }

  ${Td}:nth-child(2), ${Td}:nth-child(3) {
    white-space: unset;
    word-break: break-word;
  }
`;
